<script setup>
import { getConversationPreviewOrderId, getMessagePreviewContent } from 'dashboard/helper/conversationPreview';
import { mediaSummary } from "dashboard/helper/unavailableMedia";
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';

import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  conversation: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const { getPlainText } = useMessageFormatter();

const orderId = computed(() => getConversationPreviewOrderId(props.conversation));
const lastNonActivityMessageContent = computed(() => {
  if (orderId.value) return `订单 ${orderId.value}`;
  const { lastNonActivityMessage: lastMessage } =
    props.conversation;
  const lastNonActivityMessage = lastMessage || {};
  const attachment = lastNonActivityMessage?.attachments?.[0];
  const fileType = attachment?.fileType ?? attachment?.file_type;
  const attachmentSummary = fileType ? t(`CHAT_LIST.ATTACHMENTS.${fileType}.CONTENT`) : '';
  return getPlainText(
    mediaSummary(lastNonActivityMessage) || getMessagePreviewContent(lastNonActivityMessage) || attachmentSummary || t('CHAT_LIST.NO_CONTENT')
  );
});

const assignee = computed(() => {
  const { meta: { assignee: agent = {} } = {} } = props.conversation;
  return {
    name: agent.name ?? agent.availableName,
    thumbnail: agent.thumbnail,
    status: agent.availabilityStatus,
  };
});

const unreadMessagesCount = computed(() => {
  const { unreadCount } = props.conversation;
  return unreadCount;
});
</script>

<template>
  <div class="flex items-end w-full gap-2 pb-1">
    <p :title="orderId ? `订单号 ${orderId}` : undefined" class="w-full mb-0 text-sm leading-7 text-n-slate-12 line-clamp-2">
      {{ lastNonActivityMessageContent }}
    </p>
    <div class="flex items-center flex-shrink-0 gap-2 pb-2">
      <Avatar
        v-if="assignee.name"
        :name="assignee.name"
        :src="assignee.thumbnail"
        :size="20"
        :status="assignee.status"
        rounded-full
      />
      <div
        v-if="unreadMessagesCount > 0"
        class="inline-flex items-center justify-center rounded-full size-5 bg-n-brand"
      >
        <span class="text-xs font-semibold text-white">
          {{ unreadMessagesCount }}
        </span>
      </div>
    </div>
  </div>
</template>
